import { twMerge } from "@/utils/twMerge";

export const Description = ({ value, className }: { value: string; className?: string }) => {
  return (
    <p
      className={twMerge(
        "m-0 mb-5 p-0 font-geist font-normal text-[18px] leading-[24px] tracking-tighter",
        className,
      )}
    >
      {value}
    </p>
  );
};
